module.exports = __webpack_public_path__ + "static/media/star-default.c51e2245.svg";